export default __webpack_public_path__ + "static/2- pin detail-0181f03ee144c6c8145599efef3a31a7.gif";